import React, { FC } from 'react'
import { Modal } from 'reactstrap'
import { Prefix } from '../../models/prefix'
import InvoiceForm from './InvoiceForm'

interface CreateInvoiceModalProps {
	prefix?: Prefix

	closeModal: () => void
}
const CreateInvoiceModal: FC<CreateInvoiceModalProps> = ({ prefix, closeModal }) => (
	<Modal className="modal-dialog-centered" isOpen={prefix !== undefined} fade={true} toggle={() => closeModal()}>
		<div className="modal-body">
			<div className="d-flex justify-content-between align-items-center">
				<h1>ออกใบแจ้งหนี้ : {prefix?.prefix}</h1>
				<div className="modal-close">
					<i className="far fa-times" onClick={() => closeModal()}></i>
				</div>
			</div>
			<InvoiceForm prefix={prefix?.prefix} />
		</div>
	</Modal>
)

export default CreateInvoiceModal
